module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00067.02012c9a.png";